import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Single source of truth for report/period codes — must match DAO/mailerSubscriptionDAO.js exactly.
export const MAILER_REPORTS = {
	BATTLINK_PERFORMANCE: 0,
	BATTLINK_EXCEPTION: 1,
	CHARGLINK_PERFORMANCE: 2,
	CHARGLINK_EXCEPTION: 3,
	IOTAH_PERFORMANCE: 4,
	IOTAH_EXCEPTION: 5,
};

export const MAILER_PERIODS = {
	WEEKLY: 1,
	MONTHLY: 2,
};

export const MAILER_PERIOD_OPTIONS = [
	{ value: MAILER_PERIODS.WEEKLY, labelKey: 'site_mailer_subscriptions.period_weekly' },
	{ value: MAILER_PERIODS.MONTHLY, labelKey: 'site_mailer_subscriptions.period_monthly' },
];

const REPORT_FAMILIES = [
	{
		key: 'battlink',
		hasDevices: (siteInfo: any) => (+siteInfo.battlink_devices_count) > 0 || (+siteInfo.lithium_battlink_devices_count) > 0 || (+siteInfo.battlink_ii_devices_count) > 0,
		reports: [
			{ code: MAILER_REPORTS.BATTLINK_PERFORMANCE, labelKey: 'site_mailer_subscriptions.report_battery_performance' },
			{ code: MAILER_REPORTS.BATTLINK_EXCEPTION, labelKey: 'site_mailer_subscriptions.report_battery_exception' },
		],
	},
	{
		key: 'charglink',
		hasDevices: (siteInfo: any) => (+siteInfo.chargLink_devices_count) > 0 || (+siteInfo.brm_devices_count) > 0,
		reports: [
			{ code: MAILER_REPORTS.CHARGLINK_PERFORMANCE, labelKey: 'site_mailer_subscriptions.report_charger_performance' },
			{ code: MAILER_REPORTS.CHARGLINK_EXCEPTION, labelKey: 'site_mailer_subscriptions.report_charger_exception' },
		],
	},
	{
		key: 'iotah',
		// iotah_devices_count already excludes Power-Studies-flagged iotah devices (see DeviceFactory.group).
		hasDevices: (siteInfo: any) => (+siteInfo.iotah_devices_count) > 0,
		reports: [
			{ code: MAILER_REPORTS.IOTAH_PERFORMANCE, labelKey: 'site_mailer_subscriptions.report_truck_performance' },
			{ code: MAILER_REPORTS.IOTAH_EXCEPTION, labelKey: 'site_mailer_subscriptions.report_truck_exception' },
		],
	},
];

@Injectable({
	providedIn: 'root'
})
export class MailerSubscriptionService {

	route = '/user/';

	readonly REPORTS = MAILER_REPORTS;
	readonly PERIODS = MAILER_PERIODS;
	readonly PERIOD_OPTIONS = MAILER_PERIOD_OPTIONS;

	constructor(private httpClient: HttpClient) { }

	hasQualifyingDevices(siteInfo: any): boolean {
		return !siteInfo?.is_special && REPORT_FAMILIES.some(family => family.hasDevices(siteInfo));
	}

	getEligibleReportRows(siteInfo: any): { key: string, reports: { code: number, labelKey: string }[] }[] {
		return REPORT_FAMILIES
			.filter(family => family.hasDevices(siteInfo))
			.map(family => ({ key: family.key, reports: family.reports }));
	}

	getEligibleUsers(siteId: number) {
		return this.httpClient.post(this.route + 'get-site-mailer-subscription-users', { siteId }, {
			observe: 'body'
		});
	}

	getSubscriptions(siteId: number, userId: number) {
		return this.httpClient.post(this.route + 'get-site-mailer-subscriptions', { siteId, userId }, {
			observe: 'body'
		});
	}

	saveSubscriptions(siteId: number, userId: number, subscriptions: { report: number, periods: number[] }[]) {
		return this.httpClient.post(this.route + 'save-site-mailer-subscriptions', { siteId, userId, subscriptions }, {
			observe: 'body'
		});
	}
}
